export const hamburger = () => {
    const hamburgerContainer = document.querySelector('.header__hamburger');
    const hamburgerImg = hamburgerContainer.querySelector('.header__hamburger-img');
    const closeImg = hamburgerContainer.querySelector('.header__hamburger-close');
    const tile = document.querySelector('.tile');
    const header = document.querySelector(".header");
    const html = document.documentElement;
    const body = document.body;

    hamburgerContainer.addEventListener('click', () => {
        hamburgerImg.classList.toggle('hidden');
        closeImg.classList.toggle('hidden');
        tile.classList.toggle('tile--active');
        body.classList.toggle('no-scroll');
        html.classList.toggle('no-scroll');
        header.classList.toggle('header--opened');
    });
};